import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Sheet, SheetContent, SheetHeader, SheetTitle } from "@/components/ui/sheet";
import { api, errMsg } from "@/lib/api";
import { fmt } from "@/lib/status";
import { usePractice } from "@/pages/StaffApp";
import { StatusChip } from "@/components/PacketList";

const OPEN = ["draft", "ready", "in_signing", "awaiting_patient", "needs_review", "awaiting_witness", "signed"];

export default function FacilityDrillDown({ fac, onClose }) {
  const { setFacility } = usePractice();
  const nav = useNavigate();
  const [rows, setRows] = useState(null);
  useEffect(() => {
    if (!fac) return;
    setRows(null);
    api.get("/packets", { params: { folder: "all", facility: fac.code } })
      .then((r) => setRows(r.data.items.filter((p) => OPEN.includes(p.status)))).catch((e) => toast.error(errMsg(e)));
  }, [fac]);
  const open = (id) => { setFacility(fac.code); nav("/", { state: { sel: id, folder: "all" } }); };
  return (
    <Sheet open={!!fac} onOpenChange={(o) => !o && onClose()}>
      <SheetContent className="w-full sm:max-w-xl overflow-y-auto" data-testid="facility-drilldown">
        <SheetHeader><SheetTitle>{fac?.name} - open packets</SheetTitle></SheetHeader>
        <p className="text-xs text-slate-500 mt-1">Pending and signed-but-not-filed packets needing follow-up.</p>
        <Button size="sm" variant="outline" className="mt-3" onClick={() => { setFacility(fac.code); nav("/"); }} data-testid="drilldown-open-workspace">Open Workspace filtered to this facility</Button>
        <div className="mt-4 divide-y border rounded-lg">
          {rows === null && <p className="p-4 text-sm text-slate-500">Loading...</p>}
          {rows?.map((p) => (
            <button key={p.id} onClick={() => open(p.id)} className="w-full text-left px-3 py-2.5 hover:bg-slate-50 flex items-center gap-3 text-sm" data-testid={`drilldown-packet-${p.id}`}>
              <span className="flex-1 min-w-0"><b className="block truncate">{p.patient_name}</b><span className="text-xs text-slate-500">{p.title} - created {fmt(p.created_at)}</span></span>
              <StatusChip s={p.status} />
            </button>
          ))}
          {rows?.length === 0 && <p className="p-4 text-sm text-slate-500">Nothing open at this facility.</p>}
        </div>
      </SheetContent>
    </Sheet>
  );
}
